import { Spinner } from '@restworld/ui-ds-base';
import { cn } from '@restworld/utils-common';

export const Loader = () => (
  <ScreenSpinnerWrapper>
    <Spinner color="primary" size="lg" />
  </ScreenSpinnerWrapper>
);
const ScreenSpinnerWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('w-screen h-screen flex items-center justify-center', className)} {...props} />
);
